import Moment from "react-moment";

const DateFormat = (props) => {
  return <Moment format="MMM D YYYY">{props?.date}</Moment>;
};

export default DateFormat;
